<div class="fiserv-pos-mgr">

  <div class="fiserv-pos-mgr__list-header">
    <h4 class="fiserv-pos-mgr__section-title">Registered Terminals</h4>
    <div class="fiserv-pos-mgr__header-actions">
      <button class="fiserv-pos-mgr__btn fiserv-pos-mgr__btn--primary"
        *ngIf="!showRegisterForm"
        (click)="openRegisterForm()">
        + Register Terminal
      </button>
      <button class="fiserv-pos-mgr__btn fiserv-pos-mgr__btn--secondary"
        (click)="pingAll()" [disabled]="loading || pingingHsn !== null">
        Ping All
      </button>
      <button class="fiserv-pos-mgr__btn fiserv-pos-mgr__btn--secondary"
        (click)="loadTerminals()" [disabled]="loading">
        Refresh
      </button>
    </div>
  </div>

  <!-- Register New Terminal Form -->
  <div *ngIf="showRegisterForm"
    class="fiserv-pos-mgr__register-form">
    <h5 class="fiserv-pos-mgr__register-title">Register New Terminal</h5>
    <p class="fiserv-pos-mgr__register-hint">
      Enter the HSN from the label on the physical device.
    </p>
    <div class="fiserv-pos-mgr__register-fields">
      <div>
        <label class="fiserv-pos-mgr__label">HSN (Serial Number)</label>
        <input class="fiserv-pos-mgr__input"
          type="text"
          [(ngModel)]="newHsn"
          placeholder="e.g. C046UG52422258"
          [disabled]="registering" />
      </div>
      <div>
        <label class="fiserv-pos-mgr__label">Label</label>
        <input class="fiserv-pos-mgr__input"
          type="text"
          [(ngModel)]="newLabel"
          placeholder="e.g. Front Desk"
          [disabled]="registering" />
      </div>
      <div>
        <label class="fiserv-pos-mgr__label">Model</label>
        <select class="fiserv-pos-mgr__input"
          [(ngModel)]="newModel"
          [disabled]="registering">
          <option value="">-- Select --</option>
          <option value="Clover">Clover</option>
          <option value="Ingenico">Ingenico</option>
        </select>
      </div>
    </div>
    <div class="fiserv-pos-mgr__register-actions">
      <button class="fiserv-pos-mgr__btn fiserv-pos-mgr__btn--secondary"
        (click)="cancelRegister()" [disabled]="registering">
        Cancel
      </button>
      <button class="fiserv-pos-mgr__btn fiserv-pos-mgr__btn--primary"
        [disabled]="registering || !newHsn.trim() || !newLabel.trim() || !newModel"
        (click)="registerTerminal()">
        {{ registering ? 'Registering...' : 'Register' }}
      </button>
    </div>
  </div>

  <p class="fiserv-pos-mgr__hint">
    Terminals are provisioned by Fiserv and managed by your administrator.
    Use Ping to verify a terminal is online and reachable.
  </p>

  <div *ngIf="loading" class="fiserv-pos-mgr__loading">Loading...</div>

  <div *ngIf="!loading && terminals.length === 0" class="fiserv-pos-mgr__empty">
    No terminals registered for this clinic.
  </div>

  <table *ngIf="!loading && terminals.length > 0" class="fiserv-pos-mgr__table">
    <thead>
      <tr>
        <th>Label</th>
        <th>Model</th>
        <th>HSN</th>
        <th>Status</th>
        <th>Online</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let terminal of terminals; trackBy: trackByHsn">
        <td>{{ terminal.label ?? '—' }}</td>
        <td>{{ terminal.terminalModel ?? '—' }}</td>
        <td class="fiserv-pos-mgr__mono">{{ terminal.hsn }}</td>
        <td>
          <span class="fiserv-pos-mgr__badge"
            [class.fiserv-pos-mgr__badge--active]="terminal.isActive">
            {{ terminal.isActive ? 'Active' : 'Inactive' }}
          </span>
        </td>
        <td>
          <span *ngIf="pingStatus[terminal.hsn] === true"
            class="fiserv-pos-mgr__dot fiserv-pos-mgr__dot--on" title="Online">
          </span>
          <span *ngIf="pingStatus[terminal.hsn] === false"
            class="fiserv-pos-mgr__dot fiserv-pos-mgr__dot--off" title="Offline">
          </span>
          <span *ngIf="pingStatus[terminal.hsn] == null"
            class="fiserv-pos-mgr__dot fiserv-pos-mgr__dot--unknown" title="Unknown">
          </span>
        </td>
        <td class="fiserv-pos-mgr__actions-cell">
          <button class="fiserv-pos-mgr__btn fiserv-pos-mgr__btn--secondary"
            [disabled]="pingingHsn === terminal.hsn"
            (click)="pingTerminal(terminal.hsn)">
            {{ pingingHsn === terminal.hsn ? 'Pinging...' : 'Ping' }}
          </button>
          <button class="fiserv-pos-mgr__btn fiserv-pos-mgr__btn--danger"
            [disabled]="removingId === terminal.id"
            (click)="removeTerminal(terminal)">
            {{ removingId === terminal.id ? 'Removing...' : 'Remove' }}
          </button>
        </td>
      </tr>
    </tbody>
  </table>

</div>
